import ErrorSectionFormatter from './internal/ErrorSectionFormatter';
import ActionSectionFormatter from './internal/ActionSectionFormatter';
import { stripHtml } from '../CopilotPreview/internal/utils/Messages';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const UNSUPPORTED_TYPES = ['DATA_TABLE', 'MEDIA', 'THOUGHT', 'ACCORDION', 'CARD', 'IMAGE_GRID', 'MEDIA_V2'];
/** Component only supports displaying plain text and action buttons */
const SimpleMessageSection = ({
  section
}) => {
  if (UNSUPPORTED_TYPES.includes(section.type)) {
    return null;
  } else if (section.type === 'HTML' || section.type === 'PLAIN_TEXT' || section.type === 'LLM') {
    const plainText = stripHtml(section.text);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: plainText
    });
  } else if (section.type === 'ACTION') {
    return /*#__PURE__*/_jsx(ActionSectionFormatter, {
      section: section
    });
  }
  return /*#__PURE__*/_jsx(ErrorSectionFormatter, {});
};
export default SimpleMessageSection;